"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var types_1 = require("../types");
var constants_1 = require("../constants");
var getRouteFromHistory_1 = __importDefault(require("./getRouteFromHistory"));
var availableParentRoutes = [types_1.App.Routes.ESPORT, types_1.App.Routes.CLASSIC];
function extractParentRouteFromHistory() {
    var route = getRouteFromHistory_1.default();
    var parentRoute = route
        .split(constants_1.ROUTE_DIVIDER)
        .slice(0, 2)
        .join(constants_1.ROUTE_DIVIDER);
    return lodash_1.includes(availableParentRoutes, parentRoute)
        ? parentRoute
        : types_1.App.Routes.UPCOMING_LIST;
}
exports.default = extractParentRouteFromHistory;
//# sourceMappingURL=extractParentRouteFromHistory.js.map